"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var Tabs = function Tabs(_ref) {
  var active = _ref.active,
      _onClick = _ref.onClick,
      tabs = _ref.tabs;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_styles.Container, {
    "data-test-id": "tabs"
  }, tabs.map(function (_ref2) {
    var key = _ref2.key,
        label = _ref2.label;
    return _react["default"].createElement(_styles.Tab, {
      active: active === key,
      key: key,
      onClick: function onClick() {
        return _onClick(key);
      }
    }, label);
  })), tabs.length && _react["default"].createElement(_styles.Border, {
    activeIndex: tabs.findIndex(function (tab) {
      return tab.key === active;
    }),
    tabs: tabs.length
  }));
};

Tabs.propTypes = {
  active: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    color: _propTypes["default"].string,
    title: _propTypes["default"].string
  }))
};
Tabs.defaultProps = {
  tabs: [],
  onClick: function onClick() {}
};
var _default = Tabs;
exports["default"] = _default;